import LogoHorizontal from './src/assets/logo-horizontal.png';
import LogoSquare from './src/assets/logo-square.png';
import Logo from './src/assets/logo.png';

export const BRAND = {
  name: 'Leitourgos Vestments',
  logo: Logo,
  logoSquare: LogoSquare,
  logoHorizontal: LogoHorizontal,
  colors: {
    primary: '#010000',
    secondary: '#cdd6d0',
  },
  documentMeta: {
    title: 'Leitourgos Vestments',
    description: '',
  },
};
